import React, { useEffect, useRef } from "react";

// Site-wide zoom preview — ported from preview/index.html #lb.
// Opens any image/video on click (except the excluded surfaces), with prev/next,
// ←/→ + Esc keys, swipe on mobile, an n/total counter and click-to-magnify (2.2x).
const SKIP = "a,button,.card,.fold2,#world,.world,.mix,#ld,.ink-c,.nav,nav,header,#lb,.reel2,.rframe,.appsheet,.clients,.foot,footer,[data-nozoom]";

export function Lightbox() {
  const ref = useRef(null);

  useEffect(() => {
    const lb = ref.current;
    if (!lb) return;
    const box = lb.querySelector(".lbs");
    const cnt = lb.querySelector(".lc");
    let list = [], i = 0, tx = 0;

    const ok = (el) => el && !el.closest(SKIP) && (el.tagName === "VIDEO" || (el.naturalWidth || el.width || 0) >= 100 || !el.complete);
    const all = () => [...document.querySelectorAll("img,video")].filter(ok);
    const mark = () => all().forEach((el) => el.classList.add("zm"));
    mark();
    window.addEventListener("load", mark);

    function show() {
      const el = list[i]; box.innerHTML = ""; let m;
      if (el.tagName === "VIDEO") {
        m = document.createElement("video");
        m.src = el.currentSrc || el.src || (el.querySelector("source") || {}).src;
        m.controls = true; m.autoplay = true; m.loop = true; m.muted = false; m.playsInline = true; m.poster = el.poster || "";
      } else {
        m = document.createElement("img");
        m.src = el.dataset.full || el.currentSrc || el.src; m.alt = el.alt || "";
        m.addEventListener("click", (e) => {
          e.stopPropagation();
          const r = m.getBoundingClientRect();
          m.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + "% " + ((e.clientY - r.top) / r.height * 100) + "%";
          m.classList.toggle("z");
        });
        m.addEventListener("mousemove", (e) => {
          if (!m.classList.contains("z")) return;
          const r = m.getBoundingClientRect();
          m.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + "% " + ((e.clientY - r.top) / r.height * 100) + "%";
        });
      }
      box.appendChild(m);
      cnt.textContent = (i + 1) + " / " + list.length;
      lb.querySelector(".lp").hidden = lb.querySelector(".ln").hidden = list.length < 2;
    }
    function open(el) { list = all(); i = Math.max(0, list.indexOf(el)); lb.classList.add("on"); document.body.style.overflow = "hidden"; show(); }
    function close() { lb.classList.remove("on"); box.innerHTML = ""; document.body.style.overflow = ""; }
    const go = (d) => { i = (i + d + list.length) % list.length; show(); };

    const onDocClick = (e) => {
      const el = e.target.closest("img,video");
      if (!el || !ok(el) || lb.contains(el)) return;
      const fig = el.closest("figure");
      if (fig && fig.closest("a")) return;
      e.preventDefault(); open(el);
    };
    const onLbClick = (e) => { if (e.target === lb || e.target === box || e.target.classList.contains("x")) close(); };
    const onPrev = (e) => { e.stopPropagation(); go(-1); };
    const onNext = (e) => { e.stopPropagation(); go(1); };
    const onTouchStart = (e) => { tx = e.touches[0].clientX; };
    const onTouchEnd = (e) => { const d = e.changedTouches[0].clientX - tx; if (Math.abs(d) > 50) go(d < 0 ? 1 : -1); };
    const onKey = (e) => {
      if (!lb.classList.contains("on")) return;
      if (e.key === "Escape") close();
      if (e.key === "ArrowRight") go(1);
      if (e.key === "ArrowLeft") go(-1);
    };

    document.addEventListener("click", onDocClick);
    lb.addEventListener("click", onLbClick);
    lb.querySelector(".lp").addEventListener("click", onPrev);
    lb.querySelector(".ln").addEventListener("click", onNext);
    lb.addEventListener("touchstart", onTouchStart, { passive: true });
    lb.addEventListener("touchend", onTouchEnd);
    document.addEventListener("keydown", onKey);

    return () => {
      window.removeEventListener("load", mark);
      document.removeEventListener("click", onDocClick);
      document.removeEventListener("keydown", onKey);
      lb.removeEventListener("click", onLbClick);
      lb.querySelector(".lp").removeEventListener("click", onPrev);
      lb.querySelector(".ln").removeEventListener("click", onNext);
      lb.removeEventListener("touchstart", onTouchStart);
      lb.removeEventListener("touchend", onTouchEnd);
      document.body.style.overflow = "";
    };
  }, []);

  return (
    <div id="lb" role="dialog" aria-label="Preview" ref={ref} data-testid="zoom-lightbox">
      <button className="x" data-testid="zoom-close">Close ✕</button>
      <button className="lp" aria-label="Previous" data-testid="zoom-prev">‹</button>
      <button className="ln" aria-label="Next" data-testid="zoom-next">›</button>
      <div className="lbs" />
      <span className="lc mono" />
    </div>
  );
}
